import { useEffect, useRef, useCallback, useState } from 'react';

const WS_BASE = process.env.REACT_APP_BACKEND_URL
  ?.replace('https://', 'wss://')
  ?.replace('http://', 'ws://');

export function useOrderUpdates(token, onUpdate) {
  const wsRef = useRef(null);
  const onUpdateRef = useRef(onUpdate);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    onUpdateRef.current = onUpdate;
  }, [onUpdate]);

  const connect = useCallback(() => {
    if (!token || !WS_BASE) return;

    const ws = new WebSocket(`${WS_BASE}/ws/orders/${token}`);

    ws.onopen = () => {
      setConnected(true);
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (onUpdateRef.current) onUpdateRef.current(data);
      } catch (e) {
        if (process.env.NODE_ENV === 'development') console.warn('WS parse error:', e.message);
      }
    };

    ws.onclose = () => {
      setConnected(false);
      setTimeout(() => connect(), 5000);
    };

    ws.onerror = () => {
      ws.close();
    };

    wsRef.current = ws;
  }, [token]);

  useEffect(() => {
    connect();
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [connect]);

  return { connected };
}
